<div class="inventory-page">
  <div class="inline-error" *ngIf="showAlertError">
    <span class="inline-error-icon">!</span>
    <span>{{ errorMessage }}</span>
  </div>

  <section class="inventory-hero">
    <div class="hero-copy">
      <span class="hero-eyebrow">Inventario</span>
      <h1>{{ currentActionMeta.title }}</h1>
      <p>{{ pageSubtitle }}</p>
    </div>

    <div class="hero-badge">
      <span class="badge-label">Endpoint</span>
      <strong>{{ currentActionMeta.label }}</strong>
    </div>
  </section>

  <section class="inventory-grid">
    <article class="inventory-card upload-card">
      <div class="card-header">
        <div>
          <span class="card-kicker">Operación</span>
          <h2>Selecciona la ruta</h2>
        </div>
        <span class="card-tag">{{ currentActionMeta.label }}</span>
      </div>

      <div class="action-selector">
        <button
          type="button"
          *ngFor="let action of actionOptions"
          class="action-pill"
          [class.active]="selectedAction === action.value"
          [disabled]="action.value === 'load' && !loadActionEnabled"
          (click)="selectAction(action.value)">
          {{ action.label }}
        </button>
      </div>

      <div class="notice-banner" *ngIf="uploadResult && hasNewRecords">
        <div class="notice-content">
          <div class="notice-icon">✓</div>
          <div>
            <strong>Se detectaron placas nuevas</strong>
            <p>El archivo contiene {{ uploadResult?.placas_nuevas_propuestas?.length || 0 }} placa(s) que no existen en la base de datos.</p>
            <p class="notice-subtitle">Estas son las placas del CSV que no están en DynamoDB con estado Activo o Disponible.</p>
            <div class="notice-list">
              <ng-container *ngIf="uploadResult?.placas_nuevas_propuestas?.length">
                <p *ngFor="let placa of uploadResult.placas_nuevas_propuestas">{{ placa }} - La placa no existe en la base de datos y necesita confirmacion para su carga.</p>
              </ng-container>
            </div>
            <p class="notice-subtitle">¿Deseas añadir estos registros al inventario?</p>
          </div>
        </div>
        <div class="notice-actions">
          <button type="button" class="btn btn-primary" (click)="acceptNewRecords()">Sí, continuar</button>
          <button type="button" class="btn btn-secondary" (click)="rejectNewRecords()">No, cancelar</button>
        </div>
      </div>

      <div class="notice-banner notice-banner-warning" *ngIf="uploadResult && hasRevisionRecords">
        <div class="notice-content">
          <div class="notice-icon">!</div>
          <div>
            <div class="notice-list" *ngIf="effectiveRevisionPlates.length">
              <p *ngFor="let placa of effectiveRevisionPlates">{{ placa }} - Estas placas de inventario requieren revision, el proveedor ya no las tiene asociadas a facturacion.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="action-form" *ngIf="selectedAction === 'load'">
        <label class="toggle-row">
          <input type="checkbox" [(ngModel)]="confirmLoad" />
          <span>Confirmar carga en DynamoDB</span>
        </label>
      </div>

      <div class="action-form filters-grid" *ngIf="selectedAction === 'query'">
        <div>
          <label class="field-label">Estado</label>
          <select class="text-input" [(ngModel)]="queryFilters.estatus">
            <option [ngValue]="null">Todos</option>
            <option value="activo">Activo</option>
            <option value="historico">Historico</option>
            <option value="disponible">Disponible</option>
            <option value="devuelto">Devuelto</option>
          </select>
        </div>
        <div>
          <label class="field-label">Placa</label>
          <input class="text-input" type="text" [(ngModel)]="queryFilters.placa" placeholder="Ej. I0025754" />
        </div>
        <div>
          <label class="field-label">Usuario</label>
          <input class="text-input" type="text" [(ngModel)]="queryFilters.usuario" placeholder="Ej. usuario asignado" />
        </div>
      </div>

      <div class="action-form" *ngIf="selectedAction === 'return-to-stock'">
        <label class="field-label" for="returnToStockPlaca">Placa inventario</label>
        <input id="returnToStockPlaca" class="text-input" type="text" [(ngModel)]="returnToStockPlaca" />
      </div>

      <div class="action-form update-form" *ngIf="selectedAction === 'update'">
        <div class="update-search-row">
          <div>
            <label class="field-label" for="updateSearchPlaca">Buscar placa a modificar</label>
            <input id="updateSearchPlaca" class="text-input" type="text" [(ngModel)]="updateSearchPlaca" />
          </div>
          <div class="update-search-actions">
            <button type="button" class="btn btn-primary" (click)="searchUpdateRecord()" [disabled]="isUploading">
              Buscar placa
            </button>
            <button type="button" class="btn btn-secondary" (click)="clearUpdateState()" [disabled]="isUploading">
              Limpiar
            </button>
          </div>
        </div>

        <div class="grid-form update-fields" *ngIf="updateRecord">
          <div>
            <label class="field-label" for="updatePlaca">Placa inventario</label>
            <input id="updatePlaca" class="text-input" type="text" [(ngModel)]="updatePayload.placa_inventario" [readonly]="true" />
          </div>
          <div>
            <label class="field-label" for="updateCelular">Celular</label>
            <input id="updateCelular" class="text-input" type="text" [(ngModel)]="updatePayload.celular" />
          </div>
          <div>
            <label class="field-label" for="updateDireccion">Dirección</label>
            <input id="updateDireccion" class="text-input" type="text" [(ngModel)]="updatePayload.direccion" />
          </div>
          <div>
            <label class="field-label" for="updateObservaciones">Observaciones</label>
            <input id="updateObservaciones" class="text-input" type="text" [(ngModel)]="updatePayload.observaciones" />
          </div>
          <div>
            <label class="field-label" for="updateArea">Área</label>
            <select id="updateArea" class="text-input" [(ngModel)]="updatePayload.area">
              <option *ngFor="let area of updateAreaOptions" [value]="area">{{ area }}</option>
            </select>
          </div>
          <div>
            <label class="field-label" for="updateNombreEquipo">Nombre de equipo</label>
            <input id="updateNombreEquipo" class="text-input" type="text" [(ngModel)]="updatePayload.nombre_equipo" />
          </div>
          <div>
            <label class="field-label" for="updatePlacaCargador">Placa inventario cargador</label>
            <input id="updatePlacaCargador" class="text-input" type="text" [(ngModel)]="updatePayload.placa_inventario_cargador" />
          </div>
          <div>
            <label class="field-label" for="updatePlacaSeguridad">Placa seguridad cargador</label>
            <input id="updatePlacaSeguridad" class="text-input" type="text" [(ngModel)]="updatePayload.placa_seguridad_cargador" />
          </div>
          <div>
            <label class="field-label" for="updateValorComercial">Valor comercial</label>
            <input id="updateValorComercial" class="text-input" type="text" [(ngModel)]="updatePayload.valor_comercial" />
          </div>
          <div>
            <label class="field-label" for="updateValorPoliza">Valor póliza</label>
            <input id="updateValorPoliza" class="text-input" type="text" [(ngModel)]="updatePayload.valor_poliza" />
          </div>
        </div>

        <div class="upload-actions update-actions" *ngIf="updateRecord">
          <button type="button" class="btn btn-primary" (click)="saveUpdateRecord()" [disabled]="isUploading">
            {{ isUploading ? 'Actualizando...' : 'Actualizar cambios' }}
          </button>
        </div>
      </div>

      <div class="action-form grid-form" *ngIf="selectedAction === 'assign'">
        <div>
          <label class="field-label" for="assignPlaca">Placa inventario</label>
          <input id="assignPlaca" class="text-input" type="text" [(ngModel)]="assignPayload.placa_inventario" />
        </div>
        <div>
          <label class="field-label" for="assignUsuario">Usuario</label>
          <input id="assignUsuario" class="text-input" type="text" [(ngModel)]="assignPayload.usuario" />
        </div>
        <div>
          <label class="field-label" for="assignCelular">Celular</label>
          <input id="assignCelular" class="text-input" type="text" [(ngModel)]="assignPayload.celular" />
        </div>
        <div>
          <label class="field-label" for="assignDireccion">Dirección</label>
          <input id="assignDireccion" class="text-input" type="text" [(ngModel)]="assignPayload.direccion" />
        </div>
        <div>
          <label class="field-label" for="assignArea">Área *</label>
          <select id="assignArea" class="text-input" [(ngModel)]="assignPayload.area">
            <option value="">Selecciona un área</option>
            <option value="Tecnologia">Tecnologia</option>
            <option value="Operaciones">Operaciones</option>
            <option value="Comercial">Comercial</option>
            <option value="Riesgos">Riesgos</option>
          </select>
        </div>
        <div>
          <label class="field-label" for="assignHardware">Hardware</label>
          <input id="assignHardware" class="text-input" type="text" [(ngModel)]="assignPayload.hardware" />
        </div>
        <div>
          <label class="field-label" for="assignNombreEquipo">Nombre de equipo</label>
          <input id="assignNombreEquipo" class="text-input" type="text" [(ngModel)]="assignPayload.nombre_equipo" />
        </div>
        <div>
          <label class="field-label" for="assignPlacaCargador">Placa Inventario Cargador</label>
          <input id="assignPlacaCargador" class="text-input" type="text" [(ngModel)]="assignPayload.placa_inventario_cargador" />
        </div>
        <div>
          <label class="field-label" for="assignPlacaSeg">Placa Seguridad Cargador</label>
          <input id="assignPlacaSeg" class="text-input" type="text" [(ngModel)]="assignPayload.placa_seguridad_cargador" />
        </div>
        <div>
          <label class="field-label" for="assignSO">Sistema Operativo</label>
          <input id="assignSO" class="text-input" type="text" [(ngModel)]="assignPayload.sistema_operativo" />
        </div>
        <div>
          <label class="field-label" for="assignValorCom">Valor Comercial</label>
          <input id="assignValorCom" class="text-input" type="text" [(ngModel)]="assignPayload.valor_comercial" />
        </div>
        <div>
          <label class="field-label" for="assignValorPol">Valor Póliza</label>
          <input id="assignValorPol" class="text-input" type="text" [(ngModel)]="assignPayload.valor_poliza" />
        </div>
        <div>
          <label class="field-label" for="assignObservaciones">Observaciones</label>
          <input id="assignObservaciones" class="text-input" type="text" [(ngModel)]="assignPayload.observaciones" />
        </div>
      </div>

      <div class="action-form" *ngIf="selectedAction === 'return'">
        <label class="field-label" for="returnPlaca">Placa inventario</label>
        <input id="returnPlaca" class="text-input" type="text" [(ngModel)]="returnPlaca" />
      </div>



      <div
        *ngIf="requiresFile"
        class="drop-zone"
        [class.dragging]="isDragging"
        [class.has-file]="file"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="triggerFileInput()"
        (keydown.enter)="triggerFileInput()"
        (keydown.space)="triggerFileInput()"
        tabindex="0"
        role="button"
        [attr.aria-label]="file ? 'Archivo seleccionado: ' + fileName + '. Haz clic para cambiarlo' : 'Haz clic o arrastra un archivo CSV aquí'">
        <input
          #fileInput
          class="upload-input-hidden"
          type="file"
          accept=".csv"
          (change)="onFileSelected($event)" />

        <div class="drop-zone-content">
          <svg *ngIf="!file" class="upload-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7 16a4 4 0 0 1-.88-7.9A5 5 0 0 1 15.9 6L16 6a5 5 0 0 1 1 9.9"></path>
            <path d="M12 12v9"></path>
            <path d="m8.5 15.5 3.5-3.5 3.5 3.5"></path>
          </svg>

          <svg *ngIf="file" class="file-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 12h6"></path>
            <path d="M9 16h6"></path>
            <path d="M7 3h6l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"></path>
            <path d="M13 3v5h5"></path>
          </svg>

          <div class="drop-zone-text">
            <p class="drop-zone-title" *ngIf="!file">Arrastra tu archivo CSV aquí</p>
            <p class="drop-zone-title success" *ngIf="file">{{ fileName }}</p>
            <p class="drop-zone-subtitle" *ngIf="!file">o haz clic para seleccionar</p>
            <p class="drop-zone-subtitle" *ngIf="file">Haz clic para cambiar el archivo</p>
          </div>
        </div>
      </div>

      <div class="upload-actions" *ngIf="selectedAction !== 'update'">
        <button type="button" class="btn btn-primary" (click)="upload()" [disabled]="isUploading || (requiresFile && !file)">
          {{ isUploading ? 'Cargando...' : 'Ejecutar' }}
        </button>
        <button type="button" class="btn btn-secondary" *ngIf="file" (click)="clearFile()" [disabled]="isUploading">
          Limpiar archivo
        </button>
      </div>
    </article>

    <article class="inventory-card response-card" *ngIf="selectedAction !== 'metrics'">
      <div class="card-header">
        <div>
          <span class="card-kicker">Resultado</span>
          <h2>Estado de la operación</h2>
        </div>
        <span class="card-tag muted">Backend</span>
      </div>

      <div *ngIf="uploadResult; else emptyState" class="result-panel">
        <div class="alert-stack" *ngIf="responseAlerts.length">
          <div class="result-alert" *ngFor="let alert of responseAlerts" [class.warning]="alert.tipo === 'warning'" [class.info]="alert.tipo === 'info'">
            <strong>{{ alert.placa_inventario || 'Inventario' }}</strong>
            <span>{{ alert.mensaje }}</span>
          </div>
        </div>

        <div class="result-success">
          <strong>{{ uploadSummary }}</strong>
          <span *ngIf="uploadedAt">Procesado el {{ uploadedAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>

        <div class="result-details">
          <div class="result-header">
            <h3>Resultados</h3>
            <div *ngIf="hasResultRows && uniqueStatuses.length > 0" class="filter-group">
              <label class="filter-label">Filtrar por estado:</label>
              <select class="filter-select" [(ngModel)]="resultStatusFilter">
                <option value="">Todos ({{ resultRows.length }})</option>
                <option *ngFor="let status of uniqueStatuses" [value]="status">
                  {{ status }} ({{ getCountByStatus(status) }})
                </option>
              </select>
            </div>
          </div>
          
          <!-- Tabla de resultados si hay items -->
          <div *ngIf="hasResultRows" class="results-table-container">
            <table class="results-table">
              <thead>
                <tr>
                  <th *ngFor="let col of resultColumns">{{ getColumnLabel(col) }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filteredResultRows">
                  <td *ngFor="let col of resultColumns" [title]="row[col]">
                    {{ row[col] !== null && row[col] !== undefined ? row[col] : '-' }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="filteredResultRows.length === 0" class="no-results">
              No hay registros con el estado seleccionado.
            </div>
          </div>

          <div *ngIf="!hasResultRows" class="response-summary">
            <div class="summary-grid" *ngIf="responseSummaryEntries.length > 0; else noStructuredData">
              <div class="summary-item" *ngFor="let item of responseSummaryEntries">
                <span>{{ item.label }}</span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>

            <details *ngIf="canShowRawResponse" class="raw-response-toggle">
              <summary>Ver respuesta completa</summary>
              <pre>{{ uploadResult | json }}</pre>
            </details>

            <ng-template #noStructuredData>
              <div class="no-results">
                No hay datos estructurados para mostrar en esta respuesta.
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="empty-state">
          <div class="empty-icon">INV</div>
          <p>La respuesta del backend aparecerá aquí después de ejecutar la operación seleccionada.</p>
        </div>
      </ng-template>
    </article>
  </section>
</div>